import React from "react";
import Page from "components/common/page/Page.component";
import LoadingStatusStationContainer from "containers/dashboard/status-sensors/LoadingStatusStation.container";

const LoadingStatusStationPage = () => {
    return (
        <Page title="Stato punti di monitoraggio">
            <LoadingStatusStationContainer />
        </Page>
    );
};

export default LoadingStatusStationPage;
